// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"260":"c64ba49573d2a9f7","296":"708e47fd560a6f87","728":"ad7bc13cb64ac46d"}[chunkId] + ".js";
};